import { render, staticRenderFns } from "./PageHeaderNoAction.vue?vue&type=template&id=81ad8068&"
import script from "./PageHeaderNoAction.vue?vue&type=script&lang=js&"
export * from "./PageHeaderNoAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports